module.exports = __webpack_public_path__ + "img/B01_HQ03.4e9fe1ec.jpg";